"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processenv = void 0;
const normalize_1 = require("./normalize");
function processenv(key, defaultValue) {
    /* eslint-disable no-redeclare */
    if (!key) {
        const environmentVariables = {};
        // eslint-disable-next-line no-process-env
        Object.keys(process.env).forEach((name) => {
            // eslint-disable-next-line no-process-env
            environmentVariables[name] = normalize_1.normalize(process.env[name]);
        });
        return environmentVariables;
    }
    // eslint-disable-next-line no-process-env
    const value = process.env[key];
    if (value === undefined) {
        if (typeof defaultValue === 'function') {
            return defaultValue();
        }
        return defaultValue;
    }
    return normalize_1.normalize(value);
}
exports.processenv = processenv;
